import { Alert, AlertIcon } from 'components/v4';
import { trialEndInstructionBody } from 'pages/tpm/constants';

const CompanyApproveBanner = ({ companyData, partnerName, appAuth }) => {
    if (!companyData) {
        return null;
    }
    const isNotApproved = !companyData?.approved;
    const trialEndDate = new Date(companyData?.trialEnd + 'Z');
    const currentDate = new Date();
    const isTrialExpired = companyData?.isTrial && trialEndDate < currentDate;

    const isInvalidSync =
        Date.parse(appAuth?.lastAccessTest) >
        Date.parse(appAuth?.lastAccessSuccess);
    const isInactive = companyData?.isActive === false;
    let content = null;

    if (isNotApproved) {
        content = `Services will not provision until your company has been approved. Please contact ${partnerName} for more information.`;
    } else if (isTrialExpired) {
        content = trialEndInstructionBody.map((p, index) => (
            <span key={`${index + 1}`}>{p} &nbsp;</span>
        ));
    } else if (isInvalidSync) {
        content =
            'Service cannot connect. Please Grant Access. Calling may be disabled if this issue is not resolved';
    } else if (isInactive) {
        content =
            'This account has been deactivated and calling has been disabled. Please contact contact your provider.';
    }

    if (!content) return null;

    return (
        <Alert
            status="info"
            sx={{ marginBottom: '25px', whiteSpace: 'pre-line' }}>
            <AlertIcon />
            {content}
        </Alert>
    );
};

export default CompanyApproveBanner;
